import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {PingService} from '@app/services/api/ping.service';
import {NotificationService} from '@app/services/notification.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DOCUMENT} from '@angular/common';
import {SafariScreenFixService} from '@app/services/safari-screen-fix.service';

@Component({
    selector: 'app-maintenance-mode-page',
    templateUrl: './maintenance-mode-page.component.html',
    styleUrls: ['./maintenance-mode-page.component.scss'],
    standalone: false
})
export class MaintenanceModePageComponent implements OnInit, OnDestroy {

  public isLoading = false;
  private retryTimer: any;
  private retryDelayMs = 15000;

  constructor(private pingService: PingService,
              private notificationService: NotificationService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              @Inject(DOCUMENT) private document: Document,
              private safariScreenFix: SafariScreenFixService) {
  }

  ngOnInit(): void {
    this.refresh();
  }

  ngOnDestroy(): void {
    clearTimeout(this.retryTimer);
  }

  refresh() {
    this.isLoading = true;
    clearTimeout(this.retryTimer);

    this.pingService.ping().subscribe({
      next: () => {
        const redirect = this.safeInternalPath(this.activatedRoute.snapshot.queryParams.redirectTo)
          ?? this.router.createUrlTree(['/admin/vehicles']).toString();

        this.document.location.href = redirect;
      },
      error: () => {
        this.isLoading = false;
        // Auto-retry after delay — works regardless of error status
        this.retryTimer = setTimeout(() => this.refresh(), this.retryDelayMs);
      }
    });
  }

  isSafari() {
    return this.safariScreenFix.getIsSafari();
  }

  // Prevent open redirect (CWE-601): resolve the target through the WHATWG URL
  // parser (same one the browser applies to location.href, so tab/CR/LF stripping
  // can't smuggle a protocol-relative URL past us) and only follow same-origin
  // results, returned as a clean relative path.
  safeInternalPath(value: unknown): string | null {
    if (typeof value !== 'string' || value === '') { return null; }
    const origin = this.document.location.origin;
    try {
      const url = new URL(value, origin);
      return url.origin === origin ? url.pathname + url.search + url.hash : null;
    } catch {
      return null;
    }
  }
}
